import request from '@/utils/request'
// 查询select Report下拉数据
export const getReportTableData = params =>
  request.get('/customer-api/company-finances/page', params)
// 查询多条财报类型数据
export const getMultipleData = params =>
  request.post(
    `/customer-api/company-finances-analysis/finances-reports/manyTypes`,
    params,
  )
// 下载财务报告
export const downLoadSelectReport = params =>
  request.post(`/customer-api/company-finances-analysis/downReports`, params, {
    responseType: 'blob',
  })
// 图表数据
export const getTableData = params =>
  request.get(
    `/customer-api/company-finances-analysis/${params.financeId}/finances-reportsNew/${params.type}/${params.showAverage}/${params.exchangeRate}`,
  )
// 中间三个chart
export const getThreeChart = params =>
  request.get(
    `/customer-api/company-finances-analysis/${params.financeId}/chartsNew/${params.type}/${params.exchangeRate}`,
  )
// 根据某一个chart请求数据
export const getTheChart = params =>
  // 接口文档就这字段 compnayId
  request.post(
    `/customer-api/company-finances-analysis/charts/getImage`,
    params,
  )

export const editYear = (query, params) =>
  request.post(
    `/customer-api/company-finances-analysis/${query.compnayId}/finances-reports/${query.year}/${query.type}/${query.field}`,
    params,
  )

export const editData = params =>
  request.post(
    '/customer-api/company-finances-analysis/finances-reports/updateFinanceReport',
    params,
  )
export const callAIInterface = params =>
  request.post('/customer-api/customer/ai/updateAIAnalysis', params)
